import type { CrmTranslate } from './crm-copy';

export function createCrmAdvancedFiltersCopy(t: CrmTranslate) {
  return {
    advancedFilters: {
      title: t('crm.advancedFilters.title'),
      closeTitle: t('crm.advancedFilters.closeTitle'),
      labels: {
        jobTitle: t('crm.advancedFilters.labels.jobTitle'),
        leadStatus: t('crm.advancedFilters.labels.leadStatus'),
        status: t('crm.advancedFilters.labels.status'),
        company: t('crm.advancedFilters.labels.company'),
        role: t('crm.advancedFilters.labels.role'),
        seniority: t('crm.advancedFilters.labels.seniority'),
        stage: t('crm.advancedFilters.labels.stage'),
        priority: t('crm.advancedFilters.labels.priority'),
        entityType: t('crm.advancedFilters.labels.entityType'),
        ownerId: t('crm.advancedFilters.labels.ownerId'),
        entityId: t('crm.advancedFilters.labels.entityId'),
        city: t('crm.advancedFilters.labels.city'),
        state: t('crm.advancedFilters.labels.state'),
        country: t('crm.advancedFilters.labels.country'),
        industry: t('crm.advancedFilters.labels.industry'),
        companySize: t('crm.advancedFilters.labels.companySize'),
        hasEmail: t('crm.advancedFilters.labels.hasEmail'),
        hasPhone: t('crm.advancedFilters.labels.hasPhone'),
        hasMobile: t('crm.advancedFilters.labels.hasMobile'),
        hasWebsite: t('crm.advancedFilters.labels.hasWebsite'),
        minScore: t('crm.advancedFilters.labels.minScore'),
        maxScore: t('crm.advancedFilters.labels.maxScore'),
        minAmount: t('crm.advancedFilters.labels.minAmount'),
        maxAmount: t('crm.advancedFilters.labels.maxAmount'),
        minProbability: t('crm.advancedFilters.labels.minProbability'),
        maxProbability: t('crm.advancedFilters.labels.maxProbability'),
        contact: t('crm.advancedFilters.labels.contact'),
        assignedAgentId: t('crm.advancedFilters.labels.assignedAgentId'),
        createdAfter: t('crm.advancedFilters.labels.createdAfter'),
        createdBefore: t('crm.advancedFilters.labels.createdBefore'),
        updatedAfter: t('crm.advancedFilters.labels.updatedAfter'),
        updatedBefore: t('crm.advancedFilters.labels.updatedBefore'),
        tags: t('crm.advancedFilters.labels.tags'),
      },
      placeholders: {
        jobTitle: t('crm.advancedFilters.placeholders.jobTitle'),
        company: t('crm.advancedFilters.placeholders.company'),
        city: t('crm.advancedFilters.placeholders.city'),
        state: t('crm.advancedFilters.placeholders.state'),
        country: t('crm.advancedFilters.placeholders.country'),
        amountMin: t('crm.advancedFilters.placeholders.amountMin'),
        amountMax: t('crm.advancedFilters.placeholders.amountMax'),
        probabilityMin: t('crm.advancedFilters.placeholders.probabilityMin'),
        probabilityMax: t('crm.advancedFilters.placeholders.probabilityMax'),
        ownerId: t('crm.advancedFilters.placeholders.ownerId'),
        entityId: t('crm.advancedFilters.placeholders.entityId'),
        companySearch: t('crm.advancedFilters.placeholders.companySearch'),
        contactSearch: t('crm.advancedFilters.placeholders.contactSearch'),
        minScore: t('crm.advancedFilters.placeholders.minScore'),
        maxScore: t('crm.advancedFilters.placeholders.maxScore'),
        tags: t('crm.advancedFilters.placeholders.tags'),
        companyTags: t('crm.advancedFilters.placeholders.companyTags'),
        dealTags: t('crm.advancedFilters.placeholders.dealTags'),
      },
      emptyOptions: {
        allStatuses: t('crm.advancedFilters.emptyOptions.allStatuses'),
        allRoles: t('crm.advancedFilters.emptyOptions.allRoles'),
        allLevels: t('crm.advancedFilters.emptyOptions.allLevels'),
        allStages: t('crm.advancedFilters.emptyOptions.allStages'),
        allIndustries: t('crm.advancedFilters.emptyOptions.allIndustries'),
        allSizes: t('crm.advancedFilters.emptyOptions.allSizes'),
        allPriorities: t('crm.advancedFilters.emptyOptions.allPriorities'),
        allEntityTypes: t('crm.advancedFilters.emptyOptions.allEntityTypes'),
      },
      entitySelector: {
        noCompaniesFound: t('crm.advancedFilters.entitySelector.noCompaniesFound'),
        noContactsFound: t('crm.advancedFilters.entitySelector.noContactsFound'),
        unnamedContact: t('crm.advancedFilters.entitySelector.unnamedContact'),
      },
      actions: {
        moreOptions: t('crm.advancedFilters.actions.moreOptions'),
        showLess: t('crm.advancedFilters.actions.showLess'),
        clearAll: t('crm.advancedFilters.actions.clearAll'),
        applyFilters: t('crm.advancedFilters.actions.applyFilters'),
      },
      options: {
        leadStatuses: {
          new: t('crm.advancedFilters.options.leadStatuses.new'),
          contacted: t('crm.advancedFilters.options.leadStatuses.contacted'),
          qualified: t('crm.advancedFilters.options.leadStatuses.qualified'),
          proposal: t('crm.advancedFilters.options.leadStatuses.proposal'),
          negotiation: t('crm.advancedFilters.options.leadStatuses.negotiation'),
          closedWon: t('crm.advancedFilters.options.leadStatuses.closedWon'),
          closedLost: t('crm.advancedFilters.options.leadStatuses.closedLost'),
          unqualified: t('crm.advancedFilters.options.leadStatuses.unqualified'),
        },
        lifecycleStages: {
          subscriber: t('crm.advancedFilters.options.lifecycleStages.subscriber'),
          lead: t('crm.advancedFilters.options.lifecycleStages.lead'),
          marketingQualifiedLead: t(
            'crm.advancedFilters.options.lifecycleStages.marketingQualifiedLead'
          ),
          salesQualifiedLead: t('crm.advancedFilters.options.lifecycleStages.salesQualifiedLead'),
          opportunity: t('crm.advancedFilters.options.lifecycleStages.opportunity'),
          customer: t('crm.advancedFilters.options.lifecycleStages.customer'),
          evangelist: t('crm.advancedFilters.options.lifecycleStages.evangelist'),
          other: t('crm.advancedFilters.options.lifecycleStages.other'),
        },
        seniority: {
          individualContributor: t('crm.advancedFilters.options.seniority.individualContributor'),
          manager: t('crm.advancedFilters.options.seniority.manager'),
          director: t('crm.advancedFilters.options.seniority.director'),
          vp: t('crm.advancedFilters.options.seniority.vp'),
          cLevel: t('crm.advancedFilters.options.seniority.cLevel'),
          owner: t('crm.advancedFilters.options.seniority.owner'),
          partner: t('crm.advancedFilters.options.seniority.partner'),
        },
        employmentRoles: {
          sales: t('crm.advancedFilters.options.employmentRoles.sales'),
          marketing: t('crm.advancedFilters.options.employmentRoles.marketing'),
          engineering: t('crm.advancedFilters.options.employmentRoles.engineering'),
          product: t('crm.advancedFilters.options.employmentRoles.product'),
          design: t('crm.advancedFilters.options.employmentRoles.design'),
          operations: t('crm.advancedFilters.options.employmentRoles.operations'),
          finance: t('crm.advancedFilters.options.employmentRoles.finance'),
          hr: t('crm.advancedFilters.options.employmentRoles.hr'),
          legal: t('crm.advancedFilters.options.employmentRoles.legal'),
          executive: t('crm.advancedFilters.options.employmentRoles.executive'),
          consulting: t('crm.advancedFilters.options.employmentRoles.consulting'),
          other: t('crm.advancedFilters.options.employmentRoles.other'),
        },
        industries: {
          technology: t('crm.advancedFilters.options.industries.technology'),
          healthcare: t('crm.advancedFilters.options.industries.healthcare'),
          finance: t('crm.advancedFilters.options.industries.finance'),
          education: t('crm.advancedFilters.options.industries.education'),
          manufacturing: t('crm.advancedFilters.options.industries.manufacturing'),
          retail: t('crm.advancedFilters.options.industries.retail'),
          realEstate: t('crm.advancedFilters.options.industries.realEstate'),
          consulting: t('crm.advancedFilters.options.industries.consulting'),
          media: t('crm.advancedFilters.options.industries.media'),
          transportation: t('crm.advancedFilters.options.industries.transportation'),
          energy: t('crm.advancedFilters.options.industries.energy'),
          government: t('crm.advancedFilters.options.industries.government'),
          nonProfit: t('crm.advancedFilters.options.industries.nonProfit'),
          other: t('crm.advancedFilters.options.industries.other'),
        },
        companySize: (size: string) =>
          t('crm.advancedFilters.options.companySize', {
            values: { size },
          }),
        dealStages: {
          prospecting: t('crm.advancedFilters.options.dealStages.prospecting'),
          qualification: t('crm.advancedFilters.options.dealStages.qualification'),
          needsAnalysis: t('crm.advancedFilters.options.dealStages.needsAnalysis'),
          valueProposition: t('crm.advancedFilters.options.dealStages.valueProposition'),
          decisionMakers: t('crm.advancedFilters.options.dealStages.decisionMakers'),
          perceptionAnalysis: t('crm.advancedFilters.options.dealStages.perceptionAnalysis'),
          proposalPriceQuote: t('crm.advancedFilters.options.dealStages.proposalPriceQuote'),
          negotiationReview: t('crm.advancedFilters.options.dealStages.negotiationReview'),
          closedWon: t('crm.advancedFilters.options.dealStages.closedWon'),
          closedLost: t('crm.advancedFilters.options.dealStages.closedLost'),
        },
        taskStatuses: {
          open: t('crm.advancedFilters.options.taskStatuses.open'),
          completed: t('crm.advancedFilters.options.taskStatuses.completed'),
          cancelled: t('crm.advancedFilters.options.taskStatuses.cancelled'),
        },
        priorities: {
          low: t('crm.advancedFilters.options.priorities.low'),
          medium: t('crm.advancedFilters.options.priorities.medium'),
          high: t('crm.advancedFilters.options.priorities.high'),
        },
        entityTypes: {
          property: t('crm.advancedFilters.options.entityTypes.property'),
          listing: t('crm.advancedFilters.options.entityTypes.listing'),
          portalLead: t('crm.advancedFilters.options.entityTypes.portalLead'),
          showing: t('crm.advancedFilters.options.entityTypes.showing'),
          offer: t('crm.advancedFilters.options.entityTypes.offer'),
          transaction: t('crm.advancedFilters.options.entityTypes.transaction'),
        },
      },
    },
  };
}
